import { useEffect, useState } from 'react';
import { apiBaseUrl } from '../config/api';

export function useSitePage(slug) {
  const [state, setState] = useState({ status: 'loading', sections: [], promotions: null });

  useEffect(() => {
    const controller = new AbortController();
    fetch(`${apiBaseUrl}/api/site/pages/${slug}/`, { signal: controller.signal })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error('site'))))
      .then((data) => setState({
        status: 'ready',
        sections: Array.isArray(data.sections) ? data.sections : [],
        promotions: data.promotions || null,
      }))
      .catch((error) => {
        if (error.name === 'AbortError') return;
        setState({ status: 'error', sections: [], promotions: null });
      });
    return () => controller.abort();
  }, [slug]);

  return state;
}
